import type { DataPoint } from "@suse-o11y/data-point";
import type { Time } from "@suse-o11y/date-time/time";
import { isPresent } from "@suse-o11y/is-present";
import { max } from "@suse-o11y/max";
import { mean } from "@suse-o11y/mean";
import { min } from "@suse-o11y/min";
import { prop } from "@suse-o11y/prop";
import { sum } from "@suse-o11y/sum";

import { ALL_SINGLE_POINT_CALCULATIONS, calculateSinglePoint, isSinglePointCalculation } from "./single-point";

export const ALL_CALCULATIONS = ["mean", ...ALL_SINGLE_POINT_CALCULATIONS, "sum", "min", "max"] as const;

export type Calculation = (typeof ALL_CALCULATIONS)[number];

export function calculateValueFromPoints(
	calculation: Time | Calculation,
	points: ReadonlyArray<DataPoint>,
): undefined | number {
	if (isSinglePointCalculation(calculation)) {
		const point = calculateSinglePoint(calculation, points);

		return point?.[1] ?? undefined;
	}

	const values = points.map(prop(1));

	switch (calculation) {
		case "mean": {
			return mean(values);
		}

		case "min": {
			return min(values);
		}

		case "max": {
			return max(values);
		}

		case "sum": {
			return sum(values.filter(isPresent));
		}
	}
}
